import classNames from 'classnames';
import React from 'react';

import {
    capitalize,
    capitalizeName,
    formatAddress,
    isNotEmptyOrNull,
    formatPhoneNumber,
    removeWhitespace,
} from '@eika-infrastruktur/format';

import type { CustomerAddress, Epost, GeneralManager, Telefonnummer } from '../../generated-types';
import TranslationsConfigType from '../../translations/translationType';

export const getPhoneNumberJSX = (phoneNumberString?: Telefonnummer) => {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumberString);
    return <span>{formattedPhoneNumber}</span>;
};

export const getAddressJSX =
    (wrapperClassName?: string) =>
    (address: CustomerAddress, addressSeperator = ''): React.ReactNode => {
        const [addressText, town, postalCode] = formatAddress(address);
        const townAndPostal = [postalCode, capitalize(town)].filter(isNotEmptyOrNull).join(' ');
        return (
            <span className={wrapperClassName}>
                <span>{`${addressText}${addressSeperator}`}</span>
                {(town || postalCode) && <span>{townAndPostal}</span>}
            </span>
        );
    };

export const removeWhitespaceOnSave = (string: string) => removeWhitespace(string);

export const cleanupEmail = (email?: Epost) => email?.value.split('@').join('\u200B@') ?? '';

export const cleanupPhoneNumber = (phoneNumber?: { value: string } | string) =>
    removeWhitespaceOnSave(typeof phoneNumber === 'string' ? phoneNumber : phoneNumber?.value ?? '');

export const getGeneralManagerJSX =
    (translated: TranslationsConfigType, wrapperClassName?: string, hidePlaceholder = false) =>
    (value: GeneralManager) => {
        return (
            <div className={wrapperClassName}>
                {value.name && <span>{capitalizeName(value.name)}</span>}
                {!hidePlaceholder && (
                    <span className={classNames({ 'empty-value': !value.email })}>
                        {value.email ? cleanupEmail(value.email) : translated.contactInfo.emailMissing}
                    </span>
                )}
                {value.phoneNumber && <span>{getPhoneNumberJSX(value.phoneNumber)}</span>}
                {!value.phoneNumber && !hidePlaceholder && (
                    <span className="empty-value">{translated.contactInfo.mobileMissing}</span>
                )}
            </div>
        );
    };
